import React, { useContext, useEffect, useState } from "react";
import { Layout, Typography, Spin, Alert, message } from "antd";
import { useParams, useHistory } from "react-router-dom";
import APIUtils from "../../../api/APIUtils";
import WebLinks from "../../../api/WebLinks";
import { useAuth } from "../../../services/AuthService";
import Cookies from "js-cookie";
import constants from '../../../constants/constants';
import { useLocation } from "react-router-dom";
import { CommonContext } from "../../../Context";

const { Content } = Layout;
const { Title, Text } = Typography;

const PartnerAuth = () => {
    // const { token } = useParams();
    const location = useLocation();
    const commonContext=useContext(CommonContext);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    const history = useHistory();
    const { loginAuth } = useAuth();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const validateToken = async () => {

            if (!token) {
                message.error("Missing token");
                history.push("/login");
                return;
            };

            try {
                
                Cookies.set(constants.COOKIE_TOKEN, token, {path:'/', expires: 1 }); // Store token in cookie for 1 day

                const response = await APIUtils.apiCall(
                    "POST",
                    WebLinks.ValidatePartnerToken,
                    null,
                    true,   
                    false,
                    false
                );
                
                var isValid = true;

                if (!response.isCatch && response.resultObj.statuscode === 2000) {
                    const data = response.resultObj.data;
                    
                    loginAuth({
                        id: data.id,
                        email: data.userEmail,
                        name: data.useAuthserName,
                        type: data.userType,
                        accessToken: token
                    });
                    commonContext.changeCommonValues({'buyerId':data.buyerId});
                    Cookies.set(constants.COOKIE_LOGGED_BUYER_ID, data.buyerId, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
                    sessionStorage.setItem('selectedbuyername', data.userName);
		            Cookies.set(constants.COOKIE_HIRE_INTELLIGENCE_USER, data?.hireIntelligenceUser, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });

                    // redirect to homepage
                    window.location.href = '/welcome'; // change to homepage for partner with limited menu options
                } else {
                    // throw new Error(response.resultObj.message || "Invalid token");
                    message.error("Partner login failed");
                    // redirect after delay
                    setTimeout(() => {
                        history.push("/login");
                    }, 2000);   
                }
            } catch (err) {
                // console.error(err);
                setError("Authentication failed. Please try again.");
                message.error("Partner login failed");

                // redirect after delay
                setTimeout(() => {
                    history.push("/login");
                }, 2000);
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            validateToken();
        }
    }, [history, loginAuth]);

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Content style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div style={{ textAlign: "center", width: 400 }}>
                    {loading ? (
                        <>
                            <Spin size="large" />
                            <Title level={3}>Authenticating Partner...</Title>
                            <Text type="secondary">Please wait</Text>
                        </>
                    ) : error ? (
                        <Alert message={error} type="error" showIcon />
                    ) : null}
                </div>
            </Content>
        </Layout>
    );
};

export default PartnerAuth;